import React from "react";
import Container from "react-bootstrap/Container";
import MediaQuery from "react-responsive";
import Row from "react-bootstrap/Row";
class PrivacyChinese extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Container className="secondary_font pb-5">
        {/* FULL WIDTH CHINESE PRIVACY */}
        <MediaQuery query="(min-device-width: 1224px)">
          <div class="text-lg-center text-md-center text-sm-center text-xs-center">
            <p className="hidden-xs-down privacy-upper-title primary_font">
            </p>
            <div class="h2 hidden-sm-up privacy-title primary_font">
              Privacy Policy
            </div>
            <br />
          </div>
          <p>
            Cialfo respects your privacy and is committed to transparent privacy
            practices. This “Privacy Policy” explains how Cialfo Pte Ltd
            (collectively “Cialfo“, or “we“, or “us“, or “our“) collects, uses
            and shares your personal information in connection with your use of
            www.cialfo.co (the “Site“) and our services, and explains your
            choices for how we handle your personal information.
          </p>
          <p>
            For convenience, the Site and our services (Cialfo’s web
            application, the Android and iOS applications, and the WeChat
            application) are collectively referred to as the “Service.” This
            Privacy Policy applies only to personal information of users of the
            Site or Service.
          </p>
          <p>
            This privacy policy is compliant with the Singapore Personal Data
            Protection Act and EU General Data Protection Regulation.
          </p>
          <p>
            We’ve tried to keep this simple, but if you’re not familiar with
            terms like “cookies”, “IP addresses” or “API”, then feel free to
            email us at <a href="mailto:hello@cialfo.co">hello@cialfo.co</a>.
            Your privacy is really important to us, so whether you’re new to
            Cialfo or a long-time user, please take the time to get to know our
            practices.
          </p>
          <h3 class="text-uppercase">Personal Information We Collect</h3>
          We collect personal information about you in the following ways:
          <h5>Information that you give us</h5>
          <p>
            <strong>Account and profile information</strong>: We collect
            information about you when you register for an account, create or
            modify your profile, set preferences, or sign up for our Service.
            You also have the option to add your phone number, job title,
            country of residence, and other details to your profile information.
            We keep track of your preferences when you select settings within
            our Service.
          </p>
          <p>
            <strong>Content you provide through our products</strong>: When you
            use our Service, we collect and store content that you post, send,
            receive, or share. This content includes any information about you
            that you may choose to include. We collect feedback you provide
            directly to us through the product and; we collect content using
            analytics techniques that hash, filter or otherwise scrub the
            information to exclude information that might identify you or your
            organization; and we collect clickstream data about how you interact
            with and use features in our Service.
          </p>
          <p>
            <strong>Content you provide through our website</strong>: This
            policy also includes websites owned by or operated by Cialfo. We
            collect other content that you submit to these websites, like your
            email address, social media information, and job title and
            description.
          </p>
          <p>
            <strong>
              Information you provide through our support channels
            </strong>
            : You may choose to submit information to our customer support
            channels about a problem you’re experiencing with our Service.
            Whether you designate yourself as a technical contact, open a
            support ticket, speak to one of our representatives directly, or
            otherwise engage with our support team, you will be asked to provide
            a summary of the problem you’re experiencing and other
            documentation, screenshots, or other information that would be
            helpful in resolving the issue.
          </p>
          <h5>Information we collect automatically</h5>
          <p>
            <strong>Your use of Cialfo</strong>: We keep track of certain
            information about you when you use our Service. This information
            includes: the features you use; the links you click on; the type,
            size, and file names of attachments you upload to Cialfo; and how
            you interact with others on our Service.
          </p>
          <p>
            <strong>Your device information</strong>: We collect information
            about your computer, phone, tablet, or other devices you use to
            access our Service. This device information includes your connection
            type and settings when you install, access, update, or use our
            Service. We also collect information through your device about your
            operating system, browser type, Internet Protocol (IP) address, URLs
            of referring/exit pages, device identifiers, and crash data. We use
            your IP address and/or country preference in order to approximate
            your location to provide you with a better experience. How much of
            this information we collect depends on the type and settings of the
            device you use to access the Service.
          </p>
          <p>
            <strong>
              Cookies and similar third-party tracking technologies
            </strong>
            : Cialfo and our third-party partners, such as our advertising and
            analytics partners, use cookies and other similar tracking
            technologies to provide functionality, analyze trends, track users’
            movements around the website, and to recognize you across different
            devices. Most Web browsers are set to accept cookies by default. If
            you prefer, you can choose to set your browser to remove cookies and
            to reject cookies. If you choose to remove cookies or reject
            cookies, this could affect certain features or services of our
            Sites.
          </p>
          <p>
            <strong>Pixel tags</strong>: In addition, we also use ‘pixel tags’,
            also referred to as clear gifs, web beacons, or web bugs. Pixel tags
            are tiny graphic images with a unique identifier, similar in
            function to Cookies, that are used to track online movements of Web
            users. In contrast to Cookies, which are stored on a user’s computer
            hard drive, Pixel Tags are embedded invisibly in Web pages. Pixel
            Tags also allow us to send e-mail messages and determine whether
            those e-mails have been opened, to ensure that we are sending only
            messages that are of interest to our users. We may use this
            information to reduce or eliminate messages sent to a user.
          </p>
          <h5>Information we receive from other sources</h5>
          <p>
            <strong>Other users of Cialfo</strong>: Other users may provide
            information about you when they use our Service. For example, we
            receive your email address from other users when they invite you to
            join Cialfo.
          </p>
          <p>
            <strong>Integrations and partners of Cialfo</strong>: We may obtain
            additional information about you from our third party partners, such
            as AchieveWorks, to enrich your experience on our Service.
          </p>
          <h5>Sensitive personal information</h5>
          <p>
            We ask that you do not send or disclose to us any sensitive personal
            information (e.g., social security numbers, information related to
            racial or ethnic origin, political opinions, religion or other
            beliefs, health, biometrics or genetic characteristics, criminal
            background or union membership) on or through our Service or
            otherwise.
          </p>
          <p>
            If you send or disclose any sensitive personal information to us,
            you must consent to our processing and use of such sensitive
            personal information in accordance with this Privacy Policy. If you
            do not consent to our processing and use of such sensitive personal
            information, you must not provide it.
          </p>
          <h5>Update your personal information</h5>
          <p>
            It’s important that the personal information we hold about you is
            accurate and current. Please let us know if your personal
            information changes during your relationship with us by updating
            your account or emailing us at{" "}
            <a href="mailto:hello@cialfo.co">hello@cialfo.co</a>.
          </p>
          <h3 class="text-uppercase">How We Use Your Personal Information</h3>
          <h5>To provide the service</h5>
          <p>
            If you have a Cialfo account, we use your personal information to:
          </p>
          <ul>
            <li>
              Facilitate the creation of and securing of your Account on our
              network;
            </li>
            <li>Identify you as a user in our system;</li>
            <li>Operate, maintain, administer and improve the Service;</li>
            <li>Provide and deliver products and services you request;</li>
            <li>
              Manage and communicate with you regarding your Cialfo account, if
              you have one, including by sending you service announcements,
              technical notices, updates, security alerts, and support and
              administrative messages;
            </li>
            <li>
              Communicate with you about promotions, upcoming events, and news
              about products and services offered by Cialfo, and for other
              marketing purposes of Cialfo;
            </li>
            <li>
              Better understand your needs and interests, and personalize your
              experience with our Service;
            </li>
            <li>
              Link or combine it with other information we get from third
              parties, to help understand your needs and provide you with better
              service;
            </li>
            <li>
              Protect, investigate, and deter against fraudulent, unauthorized,
              or illegal activity; and
            </li>
            <li>Respond to your requests, questions and feedback.</li>
          </ul>
          <h5>To communicate with you</h5>
          <p>
            If you request information from us, sign up for Cialfo or
            participate in our surveys, promotions or events, we may send you
            Cialfo-related marketing communications if permitted by law but will
            provide you with the ability to opt out.
          </p>
          <h5>To comply with law</h5>
          <p>
            We use your personal information as we believe necessary or
            appropriate to comply with applicable laws, lawful requests and
            legal process, such as to respond to subpoenas or requests from
            government authorities.
          </p>
          <h5>With your consent</h5>
          <p>
            We may use or share your personal information with your consent,
            such as when you consent to let us post your testimonials or
            endorsements on our site, you instruct us to take a specific action
            with respect to your personal information or you opt into third
            party integrations.
          </p>
          <h5>To create data for analytics</h5>
          <p>
            We may create data from your personal information and other
            individuals whose personal information we collect. This data is used
            to improve our Service and to conduct research, statistical and
            behavioral analysis.
          </p>
          <h5>To create anonymized data for certain features</h5>
          <p>
            We may create anonymized data records from personal information by
            excluding information (such as your name) that makes the data
            personally identifiable to you. We use this anonymous data to power
            certain Cialfo features, such as scattergrams. We reserve the right
            to use anonymous data for any purpose and disclose anonymous data to
            third parties in our sole discretion.
          </p>
          <h5>For compliance, fraud prevention and safety</h5>
          <p>
            We use your personal information as we believe necessary or
            appropriate to (a) enforce the terms and conditions that govern our
            Service; (b) protect our rights, privacy, safety or property, and/or
            that of you or others; and (c) protect, investigate and deter
            against fraudulent, harmful, unauthorized, unethical or illegal
            activity.
          </p>
          <h3 class="text-uppercase">How We Share your Personal Information</h3>
          <p>
            Our Policy does not cover any third party services. To learn about
            those third parties’ privacy practices, please read their privacy
            policies.
          </p>
          <p>
            We do not share or sell the personal information that you provide us
            with other organizations without your express consent, except as
            described in this Privacy Policy. We disclose personal information
            to third parties under the following circumstances:
          </p>
          <ul>
            <li>
              <strong>Service Providers</strong>. We may employ third party
              companies and individuals to administer and provide the service on
              our behalf (such as customer support, hosting, email delivery and
              database management services). These third parties are permitted
              to use your personal information only to perform these tasks in a
              manner consistent with this Privacy Policy and are obligated not
              to disclose or use it for any other purpose.
            </li>
            <li>
              <strong>Professional advisors</strong>. We may disclose your
              personal information to professional advisors, such as lawyers,
              bankers, auditors and insurers, where necessary in the course of
              the professional services that they render to us.
            </li>
            <li>
              <strong>Lawful requests</strong>. Cialfo may disclose information
              about you to government or law enforcement officials or private
              parties as required by law, and disclose and use such information
              as we believe necessary or appropriate to (a) comply with
              applicable laws and lawful requests and legal process, such as to
              respond to subpoenas or requests from government authorities; (b)
              enforce the terms and conditions that govern the service; (d)
              protect our rights, privacy, safety or property, and/or that of
              you or others; and (e) protect, investigate and deter against
              fraudulent, harmful, unauthorized, unethical or illegal activity.
            </li>
            <li>
              <strong>Business Transfers</strong>. Cialfo may sell, transfer or
              otherwise share some or all of its business or assets, including
              your personal information, in connection with a business deal (or
              potential business deal) such as a merger, consolidation,
              acquisition, reorganization or sale of assets or in the event of
              bankruptcy, in which case we will make reasonable efforts to
              require the recipient to honor this Privacy Policy.
            </li>
          </ul>
          <h3 class="text-uppercase">Platform Activities</h3>
          <p>
            With respects to our Service, Cialfo collects information under the
            direction of its customers (the data controller), and has no direct
            relationship with the individuals whose personal information it
            processes. If you are a customer of one of our customers and would
            no longer like to be contacted by one of our customers that use our
            service, please contact the customer that you interact with
            directly. We may transfer personal information to companies that
            help us provide our service. Transfers to subsequent third parties
            are covered by the service agreements with our customers.
          </p>
          <p>
            Cialfo acknowledges that you have the right to access your personal
            information. Cialfo has no direct relationship with the individuals
            whose personal information it processes. An individual who seeks
            access, or who seeks to correct, amend, or delete inaccurate data
            should direct his or her query to the Cialfo’s customer (the data
            controller). If requested to remove data, we will respond within a
            reasonable timeframe.
          </p>
          <p>
            We will retain personal information we process on behalf of our
            customer for as long as needed to provide services to our customer.
            Cialfo will retain this personal information as necessary to comply
            with our legal obligations, resolve disputes, and enforce our
            agreements.
          </p>
          <h3 class="text-uppercase">Security</h3>
          <p>
            The security of your personal information important to us. We take a
            number of commercially reasonable organizational, technical and
            physical measures designed to protect the personal information we
            collect, both during transmission and once we receive it.
          </p>
          <p>
            However, no security safeguards are 100% secure. It is your
            responsibility to protect your usernames and passwords to help
            prevent anyone from accessing or abusing your accounts and services.
            You should not use or reuse the same passwords you use with other
            accounts as your password for our Service.
          </p>
          <h3 class="text-uppercase">International Transfer</h3>
          <p>
            Cialfo is headquartered in Singapore and has affiliates and service
            providers in other countries. Your personal information may be
            transferred to Singapore, Japan, or other locations outside of your
            state, province, country or other governmental jurisdiction where
            privacy laws may not be as protective as those in your jurisdiction.
            In addition, Cialfo personnel may need access to data stored in the
            EU from a non-EU country (e.g., U.S, Singapore, China or India) for
            technical and support related reasons.
          </p>
          <h3 class="text-uppercase">Other sites and services</h3>
          <p>
            The service may contain links to other websites and services. These
            links are not an endorsement, authorization or representation that
            we are affiliated with that third party. We do not exercise control
            over third party websites or services, and are not responsible for
            their actions. Other websites and services follow different rules
            regarding the use or disclosure of the personal information you
            submit to them. We encourage you to read the privacy policies of the
            other websites you visit and services you use.
          </p>
          <h3 class="text-uppercase">Social Media Widgets</h3>
          <p>
            Our site may include social media features, such as the Facebook
            “like” button and widgets, such as the “share this” button. These
            features may collect your personal information and track your use of
            the site. These social media features are either hosted by a third
            party or hosted directly on our site. Your interactions with these
            features are governed by the privacy policy of the company providing
            such functionality.
          </p>
          <h3 class="text-uppercase">User Generated Content</h3>
          <p>
            We may make available on our site, or link to, features that allow
            you to share information online (e.g., on message boards, in chat
            areas, in file uploads, through events, etc.). Please be aware that
            whenever you voluntarily disclose personal information online, that
            information becomes public and can be collected and used by others.
            We have no control over, and take no responsibility for, the use,
            storage or dissemination of such publicly-disclosed personal
            information. By posting personal information online in public
            forums, you may receive unsolicited messages from other parties.
          </p>
          <h3 class="text-uppercase">Children</h3>
          <p>
            We do not knowingly acquire or receive personal information from
            children under the age of 13. If you are under the age of 13, you
            are not permitted to submit any personal information to us. If we
            later learn that any user of our Service is under the age of 13, we
            will take appropriate steps to remove that user’s information from
            our account database and will restrict that individual from future
            access to the Service.
          </p>
          <p>
            If you believe that we might have any personal information from a
            child under 13, please contact us at{" "}
            <a href="mailto:hello@cialfo.co">hello@cialfo.co</a>.
          </p>
          <h5>Changes to this Privacy Policy</h5>
          <p>
            We reserve the right to modify this Privacy Policy at any time. We
            encourage you to periodically review this page for the latest
            information on our privacy practices. If we make material changes to
            this Privacy Policy you will be notified via email (if you have an
            account where we have your contact information) or another manner
            through the service that we believe reasonably likely to reach you
            (which may include posting a new privacy policy on our site – or a
            specific announcement on this page or on our blog).
          </p>
          <p>
            Any modifications to this Privacy Policy will be effective upon our
            posting of the new terms and/or upon implementation of the new
            changes on the service (or as otherwise indicated at the time of
            posting). In all cases, your continued use of the service after the
            posting of any modified Privacy Policy indicates your acceptance of
            the terms of the modified Privacy Policy.
          </p>
          <h3 class="text-uppercase">Your Choices</h3>
          <h5>Access, Update, Correct or Delete Your Information</h5>
          <p>
            All Cialfo account holders may review, update, correct or delete the
            personal information in their registration profile by logging into
            their account. Cialfo retains your data while you are a customer and
            will delete your personal information upon written request.
            Individuals who have provided information to Cialfo’s customers must
            send requests to change or delete such information to the particular
            Cialfo customer.
          </p>
          <p>
            Cialfo account holders may also contact us at{" "}
            <a href="mailto:hello@cialfo.co">hello@cialfo.co</a> to accomplish
            the foregoing or if you have additional requests or questions.
          </p>
          <h5>Access to Data Controlled by our Clients</h5>
          <p>
            Cialfo has no direct relationship with the individuals whose
            personal information is contained within the Client User Data
            processed by our service. An individual who seeks access, or who
            seeks to correct, amend, or delete personal information provided by
            our Clients should direct their request to the Client. You may also
            contact us at <a href="mailto:hello@cialfo.co">hello@cialfo.co</a>{" "}
            if you have additional questions or concerns.
          </p>
          <h5>Marketing Communications</h5>
          <p>
            You may opt out of marketing-related emails by clicking on a link at
            the bottom of each such email. You may continue to receive
            service-related and other non-marketing emails.
          </p>
          <h5>Testimonials</h5>
          <p>
            If you gave us consent to post a testimonial to our site, but wish
            to update or delete it, please contact us.
          </p>
          <h5>Tracking and Targeted Advertising</h5>
          <p>
            We may allow service providers and other third parties to use
            cookies and other tracking technologies to track your browsing
            activity over time and across our site and third party websites. We
            may also partner with a third party ad network to either display
            advertising on our site, to manage our advertising on other sites,
            or to provide you targeted advertisements based upon your interests
            on our site or on third party sites.
          </p>
          <p>
            Some Internet browsers may be configured to send “Do Not Track”
            signals to the online services that you visit. Cialfo honors “Do Not
            Track” signals. To find out more about “Do Not Track,” please visit{" "}
            <a href=" http://www.allaboutdnt.com." target="_blank">
              http://www.allaboutdnt.com.
            </a>
          </p>
          <p>
            In some of our communications, we use tracking means, such as a
            “click-through URL” linked to content on the site. We track this
            data to help us measure the effectiveness of our customer
            communications.
          </p>
          <h5>Choosing not to share your personal information</h5>
          <p>
            Where we need to collect your personal information by law, or to be
            able to provide the service to you and you do not provide that
            information when requested (or you later ask to delete it), we may
            not be able to provide you with the service and may need to close
            your account. We will tell you what information you must provide to
            receive the service by designating it as required in the service or
            through other appropriate means.
          </p>
          <h3 class="text-uppercase">Questions?</h3>
          <p>
            If you have any questions or concerns at all about our Privacy
            Policy, please feel free to email us at{" "}
            <a href="mailto:hello@cialfo.co">hello@cialfo.co</a>. Or, if you’re
            feeling old fashioned, use snail mail:
          </p>
          <p>
            Cialfo
            <br />
            52 Joo Chiat Road
            <br />
            Singapore 427374
            <br />
            Attention: Data Protection Officer
          </p>
          <h3 class="text-uppercase">
            Additional Information for European Union Users
          </h3>
          <h5>Personal information</h5>
          <p>
            References to “personal information” in this Privacy Policy are
            equivalent to “personal data” governed by European data protection
            legislation.
          </p>
          <h5>Controller and Data Protection Officer</h5>
          <p>
            Cialfo is the controller of your personal information for purposes
            of European data protection legislation. Our Data Protection Officer
            can be reached at{" "}
            <a href="mailto:hello@cialfo.co">hello@cialfo.co</a>.
          </p>
        </MediaQuery>
        {/* MOBILE CHINESE PRIVACY */}
        <MediaQuery query="(max-device-width: 1223px)">
          <Container>
            <div class="text-lg-center text-md-center text-sm-center text-xs-center">
              <Row className="center-in-row">
                <p className="hidden-xs-down primary_font privacy-upper-title">
                  Cialfo
                </p>
              </Row>
              <Row className="center-in-row px-4">
                <div class="h1 hidden-sm-up primary_font mobile-privacy-title">
                  Privacy Policy
                </div>
              </Row>
              <br />
            </div>
            <Container className="px-3">
              <p>
                Cialfo respects your privacy and is committed to transparent
                privacy practices. This “Privacy Policy” explains how Cialfo Pte
                Ltd (collectively “Cialfo“, or “we“, or “us“, or “our“)
                collects, uses and shares your personal information in
                connection with your use of www.cialfo.co (the “Site“) and our
                services, and explains your choices for how we handle your
                personal information.
              </p>
              <p>
                For convenience, the Site and our services (Cialfo’s web
                application, the Android and iOS applications, and the WeChat
                application) are collectively referred to as the “Service.” This
                Privacy Policy applies only to personal information of users of
                the Site or Service.
              </p>
              <p>
                This privacy policy is compliant with the Singapore Personal
                Data Protection Act and EU General Data Protection Regulation.
              </p>
              <p>
                We’ve tried to keep this simple, but if you’re not familiar with
                terms like “cookies”, “IP addresses” or “API”, then feel free to
                email us at <a href="mailto:hello@cialfo.co">hello@cialfo.co</a>
                . Your privacy is really important to us, so whether you’re new
                to Cialfo or a long-time user, please take the time to get to
                know our practices.
              </p>
              <h3 class="text-uppercase">Personal Information We Collect</h3>
              We collect personal information about you in the following ways:
              <h5>Information that you give us</h5>
              <p>
                <strong>Account and profile information</strong>: We collect
                information about you when you register for an account, create
                or modify your profile, set preferences, or sign up for our
                Service. You also have the option to add your phone number, job
                title, country of residence, and other details to your profile
                information. We keep track of your preferences when you select
                settings within our Service.
              </p>
              <p>
                <strong>Content you provide through our products</strong>: When
                you use our Service, we collect and store content that you post,
                send, receive, or share. This content includes any information
                about you that you may choose to include. We collect feedback
                you provide directly to us through the product and; we collect
                content using analytics techniques that hash, filter or
                otherwise scrub the information to exclude information that
                might identify you or your organization; and we collect
                clickstream data about how you interact with and use features in
                our Service.
              </p>
              <p>
                <strong>Content you provide through our website</strong>: This
                policy also includes websites owned by or operated by Cialfo. We
                collect other content that you submit to these websites, like
                your email address, social media information, and job title and
                description.
              </p>
              <p>
                <strong>
                  Information you provide through our support channels
                </strong>
                : You may choose to submit information to our customer support
                channels about a problem you’re experiencing with our Service.
                Whether you designate yourself as a technical contact, open a
                support ticket, speak to one of our representatives directly, or
                otherwise engage with our support team, you will be asked to
                provide a summary of the problem you’re experiencing and other
                documentation, screenshots, or other information that would be
                helpful in resolving the issue.
              </p>
              <h5>Information we collect automatically</h5>
              <p>
                <strong>Your use of Cialfo</strong>: We keep track of certain
                information about you when you use our Service. This information
                includes: the features you use; the links you click on; the
                type, size, and file names of attachments you upload to Cialfo;
                and how you interact with others on our Service.
              </p>
              <p>
                <strong>Your device information</strong>: We collect information
                about your computer, phone, tablet, or other devices you use to
                access our Service. This device information includes your
                connection type and settings when you install, access, update,
                or use our Service. We also collect information through your
                device about your operating system, browser type, Internet
                Protocol (IP) address, URLs of referring/exit pages, device
                identifiers, and crash data. We use your IP address and/or
                country preference in order to approximate your location to
                provide you with a better experience. How much of this
                information we collect depends on the type and settings of the
                device you use to access the Service.
              </p>
              <p>
                <strong>
                  Cookies and similar third-party tracking technologies
                </strong>
                : Cialfo and our third-party partners, such as our advertising
                and analytics partners, use cookies and other similar tracking
                technologies to provide functionality, analyze trends, track
                users’ movements around the website, and to recognize you across
                different devices. Most Web browsers are set to accept cookies
                by default. If you prefer, you can choose to set your browser to
                remove cookies and to reject cookies. If you choose to remove
                cookies or reject cookies, this could affect certain features or
                services of our Sites.
              </p>
              <p>
                <strong>Pixel tags</strong>: In addition, we also use ‘pixel
                tags’, also referred to as clear gifs, web beacons, or web bugs.
                Pixel tags are tiny graphic images with a unique identifier,
                similar in function to Cookies, that are used to track online
                movements of Web users. In contrast to Cookies, which are stored
                on a user’s computer hard drive, Pixel Tags are embedded
                invisibly in Web pages. Pixel Tags also allow us to send e-mail
                messages and determine whether those e-mails have been opened,
                to ensure that we are sending only messages that are of interest
                to our users. We may use this information to reduce or eliminate
                messages sent to a user.
              </p>
              <h5>Information we receive from other sources</h5>
              <p>
                <strong>Other users of Cialfo</strong>: Other users may provide
                information about you when they use our Service. For example, we
                receive your email address from other users when they invite you
                to join Cialfo.
              </p>
              <p>
                <strong>Integrations and partners of Cialfo</strong>: We may
                obtain additional information about you from our third party
                partners, such as AchieveWorks, to enrich your experience on our
                Service.
              </p>
              <h5>Sensitive personal information</h5>
              <p>
                We ask that you do not send or disclose to us any sensitive
                personal information (e.g., social security numbers, information
                related to racial or ethnic origin, political opinions, religion
                or other beliefs, health, biometrics or genetic characteristics,
                criminal background or union membership) on or through our
                Service or otherwise.
              </p>
              <p>
                If you send or disclose any sensitive personal information to
                us, you must consent to our processing and use of such sensitive
                personal information in accordance with this Privacy Policy. If
                you do not consent to our processing and use of such sensitive
                personal information, you must not provide it.
              </p>
              <h5>Update your personal information</h5>
              <p>
                It’s important that the personal information we hold about you
                is accurate and current. Please let us know if your personal
                information changes during your relationship with us by updating
                your account or emailing us at{" "}
                <a href="mailto:hello@cialfo.co">hello@cialfo.co</a>.
              </p>
              <h3 class="text-uppercase">
                How We Use Your Personal Information
              </h3>
              <h5>To provide the service</h5>
              <p>
                If you have a Cialfo account, we use your personal information
                to:
              </p>
              <ul>
                <li>
                  Facilitate the creation of and securing of your Account on our
                  network;
                </li>
                <li>Identify you as a user in our system;</li>
                <li>Operate, maintain, administer and improve the Service;</li>
                <li>Provide and deliver products and services you request;</li>
                <li>
                  Manage and communicate with you regarding your Cialfo account,
                  if you have one, including by sending you service
                  announcements, technical notices, updates, security alerts,
                  and support and administrative messages;
                </li>
                <li>
                  Communicate with you about promotions, upcoming events, and
                  news about products and services offered by Cialfo, and for
                  other marketing purposes of Cialfo;
                </li>
                <li>
                  Better understand your needs and interests, and personalize
                  your experience with our Service;
                </li>
                <li>
                  Link or combine it with other information we get from third
                  parties, to help understand your needs and provide you with
                  better service;
                </li>
                <li>
                  Protect, investigate, and deter against fraudulent,
                  unauthorized, or illegal activity; and
                </li>
                <li>Respond to your requests, questions and feedback.</li>
              </ul>
              <h5>To communicate with you</h5>
              <p>
                If you request information from us, sign up for Cialfo or
                participate in our surveys, promotions or events, we may send
                you Cialfo-related marketing communications if permitted by law
                but will provide you with the ability to opt out.
              </p>
              <h5>To comply with law</h5>
              <p>
                We use your personal information as we believe necessary or
                appropriate to comply with applicable laws, lawful requests and
                legal process, such as to respond to subpoenas or requests from
                government authorities.
              </p>
              <h5>With your consent</h5>
              <p>
                We may use or share your personal information with your consent,
                such as when you consent to let us post your testimonials or
                endorsements on our site, you instruct us to take a specific
                action with respect to your personal information or you opt into
                third party integrations.
              </p>
              <h5>To create data for analytics</h5>
              <p>
                We may create data from your personal information and other
                individuals whose personal information we collect. This data is
                used to improve our Service and to conduct research, statistical
                and behavioral analysis.
              </p>
              <h5>To create anonymized data for certain features</h5>
              <p>
                We may create anonymized data records from personal information
                by excluding information (such as your name) that makes the data
                personally identifiable to you. We use this anonymous data to
                power certain Cialfo features, such as scattergrams. We reserve
                the right to use anonymous data for any purpose and disclose
                anonymous data to third parties in our sole discretion.
              </p>
              <h5>For compliance, fraud prevention and safety</h5>
              <p>
                We use your personal information as we believe necessary or
                appropriate to (a) enforce the terms and conditions that govern
                our Service; (b) protect our rights, privacy, safety or
                property, and/or that of you or others; and (c) protect,
                investigate and deter against fraudulent, harmful, unauthorized,
                unethical or illegal activity.
              </p>
              <h3 class="text-uppercase">
                How We Share your Personal Information
              </h3>
              <p>
                Our Policy does not cover any third party services. To learn
                about those third parties’ privacy practices, please read their
                privacy policies.
              </p>
              <p>
                We do not share or sell the personal information that you
                provide us with other organizations without your express
                consent, except as described in this Privacy Policy. We disclose
                personal information to third parties under the following
                circumstances:
              </p>
              <ul>
                <li>
                  <strong>Service Providers</strong>. We may employ third party
                  companies and individuals to administer and provide the
                  service on our behalf (such as customer support, hosting,
                  email delivery and database management services). These third
                  parties are permitted to use your personal information only to
                  perform these tasks in a manner consistent with this Privacy
                  Policy and are obligated not to disclose or use it for any
                  other purpose.
                </li>
                <li>
                  <strong>Professional advisors</strong>. We may disclose your
                  personal information to professional advisors, such as
                  lawyers, bankers, auditors and insurers, where necessary in
                  the course of the professional services that they render to
                  us.
                </li>
                <li>
                  <strong>Lawful requests</strong>. Cialfo may disclose
                  information about you to government or law enforcement
                  officials or private parties as required by law, and disclose
                  and use such information as we believe necessary or
                  appropriate to (a) comply with applicable laws and lawful
                  requests and legal process, such as to respond to subpoenas or
                  requests from government authorities; (b) enforce the terms
                  and conditions that govern the service; (d) protect our
                  rights, privacy, safety or property, and/or that of you or
                  others; and (e) protect, investigate and deter against
                  fraudulent, harmful, unauthorized, unethical or illegal
                  activity.
                </li>
                <li>
                  <strong>Business Transfers</strong>. Cialfo may sell, transfer
                  or otherwise share some or all of its business or assets,
                  including your personal information, in connection with a
                  business deal (or potential business deal) such as a merger,
                  consolidation, acquisition, reorganization or sale of assets
                  or in the event of bankruptcy, in which case we will make
                  reasonable efforts to require the recipient to honor this
                  Privacy Policy.
                </li>
              </ul>
              <h3 class="text-uppercase">Platform Activities</h3>
              <p>
                With respects to our Service, Cialfo collects information under
                the direction of its customers (the data controller), and has no
                direct relationship with the individuals whose personal
                information it processes. If you are a customer of one of our
                customers and would no longer like to be contacted by one of our
                customers that use our service, please contact the customer that
                you interact with directly. We may transfer personal information
                to companies that help us provide our service. Transfers to
                subsequent third parties are covered by the service agreements
                with our customers.
              </p>
              <p>
                Cialfo acknowledges that you have the right to access your
                personal information. Cialfo has no direct relationship with the
                individuals whose personal information it processes. An
                individual who seeks access, or who seeks to correct, amend, or
                delete inaccurate data should direct his or her query to the
                Cialfo’s customer (the data controller). If requested to remove
                data, we will respond within a reasonable timeframe.
              </p>
              <p>
                We will retain personal information we process on behalf of our
                customer for as long as needed to provide services to our
                customer. Cialfo will retain this personal information as
                necessary to comply with our legal obligations, resolve
                disputes, and enforce our agreements.
              </p>
              <h3 class="text-uppercase">Security</h3>
              <p>
                The security of your personal information important to us. We
                take a number of commercially reasonable organizational,
                technical and physical measures designed to protect the personal
                information we collect, both during transmission and once we
                receive it.
              </p>
              <p>
                However, no security safeguards are 100% secure. It is your
                responsibility to protect your usernames and passwords to help
                prevent anyone from accessing or abusing your accounts and
                services. You should not use or reuse the same passwords you use
                with other accounts as your password for our Service.
              </p>
              <h3 class="text-uppercase">International Transfer</h3>
              <p>
                Cialfo is headquartered in Singapore and has affiliates and
                service providers in other countries. Your personal information
                may be transferred to Singapore, Japan, or other locations
                outside of your state, province, country or other governmental
                jurisdiction where privacy laws may not be as protective as
                those in your jurisdiction. In addition, Cialfo personnel may
                need access to data stored in the EU from a non-EU country
                (e.g., U.S, Singapore, China or India) for technical and support
                related reasons.
              </p>
              <h3 class="text-uppercase">Other sites and services</h3>
              <p>
                The service may contain links to other websites and services.
                These links are not an endorsement, authorization or
                representation that we are affiliated with that third party. We
                do not exercise control over third party websites or services,
                and are not responsible for their actions. Other websites and
                services follow different rules regarding the use or disclosure
                of the personal information you submit to them. We encourage you
                to read the privacy policies of the other websites you visit and
                services you use.
              </p>
              <h3 class="text-uppercase">Social Media Widgets</h3>
              <p>
                Our site may include social media features, such as the Facebook
                “like” button and widgets, such as the “share this” button.
                These features may collect your personal information and track
                your use of the site. These social media features are either
                hosted by a third party or hosted directly on our site. Your
                interactions with these features are governed by the privacy
                policy of the company providing such functionality.
              </p>
              <h3 class="text-uppercase">User Generated Content</h3>
              <p>
                We may make available on our site, or link to, features that
                allow you to share information online (e.g., on message boards,
                in chat areas, in file uploads, through events, etc.). Please be
                aware that whenever you voluntarily disclose personal
                information online, that information becomes public and can be
                collected and used by others. We have no control over, and take
                no responsibility for, the use, storage or dissemination of such
                publicly-disclosed personal information. By posting personal
                information online in public forums, you may receive unsolicited
                messages from other parties.
              </p>
              <h3 class="text-uppercase">Children</h3>
              <p>
                We do not knowingly acquire or receive personal information from
                children under the age of 13. If you are under the age of 13,
                you are not permitted to submit any personal information to us.
                If we later learn that any user of our Service is under the age
                of 13, we will take appropriate steps to remove that user’s
                information from our account database and will restrict that
                individual from future access to the Service.
              </p>
              <p>
                If you believe that we might have any personal information from
                a child under 13, please contact us at{" "}
                <a href="mailto:hello@cialfo.co">hello@cialfo.co</a>.
              </p>
              <h5>Changes to this Privacy Policy</h5>
              <p>
                We reserve the right to modify this Privacy Policy at any time.
                We encourage you to periodically review this page for the latest
                information on our privacy practices. If we make material
                changes to this Privacy Policy you will be notified via email
                (if you have an account where we have your contact information)
                or another manner through the service that we believe reasonably
                likely to reach you (which may include posting a new privacy
                policy on our site – or a specific announcement on this page or
                on our blog).
              </p>
              <p>
                Any modifications to this Privacy Policy will be effective upon
                our posting of the new terms and/or upon implementation of the
                new changes on the service (or as otherwise indicated at the
                time of posting). In all cases, your continued use of the
                service after the posting of any modified Privacy Policy
                indicates your acceptance of the terms of the modified Privacy
                Policy.
              </p>
              <h3 class="text-uppercase">Your Choices</h3>
              <h5>Access, Update, Correct or Delete Your Information</h5>
              <p>
                All Cialfo account holders may review, update, correct or delete
                the personal information in their registration profile by
                logging into their account. Cialfo retains your data while you
                are a customer and will delete your personal information upon
                written request. Individuals who have provided information to
                Cialfo’s customers must send requests to change or delete such
                information to the particular Cialfo customer.
              </p>
              <p>
                Cialfo account holders may also contact us at{" "}
                <a href="mailto:hello@cialfo.co">hello@cialfo.co</a> to
                accomplish the foregoing or if you have additional requests or
                questions.
              </p>
              <h5>Access to Data Controlled by our Clients</h5>
              <p>
                Cialfo has no direct relationship with the individuals whose
                personal information is contained within the Client User Data
                processed by our service. An individual who seeks access, or who
                seeks to correct, amend, or delete personal information provided
                by our Clients should direct their request to the Client. You
                may also contact us at{" "}
                <a href="mailto:hello@cialfo.co">hello@cialfo.co</a> if you have
                additional questions or concerns.
              </p>
              <h5>Marketing Communications</h5>
              <p>
                You may opt out of marketing-related emails by clicking on a
                link at the bottom of each such email. You may continue to
                receive service-related and other non-marketing emails.
              </p>
              <h5>Testimonials</h5>
              <p>
                If you gave us consent to post a testimonial to our site, but
                wish to update or delete it, please contact us.
              </p>
              <h5>Tracking and Targeted Advertising</h5>
              <p>
                We may allow service providers and other third parties to use
                cookies and other tracking technologies to track your browsing
                activity over time and across our site and third party websites.
                We may also partner with a third party ad network to either
                display advertising on our site, to manage our advertising on
                other sites, or to provide you targeted advertisements based
                upon your interests on our site or on third party sites.
              </p>
              <p>
                Some Internet browsers may be configured to send “Do Not Track”
                signals to the online services that you visit. Cialfo honors “Do
                Not Track” signals. To find out more about “Do Not Track,”
                please visit{" "}
                <a href=" http://www.allaboutdnt.com." target="_blank">
                  http://www.allaboutdnt.com.
                </a>
              </p>
              <p>
                In some of our communications, we use tracking means, such as a
                “click-through URL” linked to content on the site. We track this
                data to help us measure the effectiveness of our customer
                communications.
              </p>
              <h5>Choosing not to share your personal information</h5>
              <p>
                Where we need to collect your personal information by law, or to
                be able to provide the service to you and you do not provide
                that information when requested (or you later ask to delete it),
                we may not be able to provide you with the service and may need
                to close your account. We will tell you what information you
                must provide to receive the service by designating it as
                required in the service or through other appropriate means.
              </p>
              <h3 class="text-uppercase">Questions?</h3>
              <p>
                If you have any questions or concerns at all about our Privacy
                Policy, please feel free to email us at{" "}
                <a href="mailto:hello@cialfo.co">hello@cialfo.co</a>. Or, if
                you’re feeling old fashioned, use snail mail:
              </p>
              <p>
                Cialfo
                <br />
                52 Joo Chiat Road
                <br />
                Singapore 427374
                <br />
                Attention: Data Protection Officer
              </p>
              <h3 class="text-uppercase">
                Additional Information for European Union Users
              </h3>
              <h5>Personal information</h5>
              <p>
                References to “personal information” in this Privacy Policy are
                equivalent to “personal data” governed by European data
                protection legislation.
              </p>
              <h5>Controller and Data Protection Officer</h5>
              <p>
                Cialfo is the controller of your personal information for
                purposes of European data protection legislation. Our Data
                Protection Officer can be reached at{" "}
                <a href="mailto:hello@cialfo.co">hello@cialfo.co</a>.
              </p>
            </Container>
          </Container>
        </MediaQuery>
      </Container>
    );
  }
}

export default PrivacyChinese;
